function pickFirst(...values) {
  return values.find((v) => v !== undefined && v !== null && String(v).trim() !== '');
}

function buildProfileName(profile) {
  if (!profile) return '-';
  const firstName = pickFirst(profile.firstName, profile.first_name);
  const lastName = pickFirst(profile.lastName, profile.last_name);
  const fullName = [firstName, lastName].filter(Boolean).join(' ').trim();
  return fullName || pickFirst(profile.email, profile.uid) || '-';
}

function normalizeCommissions(payload) {
  if (Array.isArray(payload?.commissions)) return payload.commissions;
  if (payload?.commissions && typeof payload.commissions === 'object') return Object.values(payload.commissions);
  if (Array.isArray(payload)) return payload;
  return [];
}

export function mapCommissionsResponseToDto(payload) {
  return normalizeCommissions(payload).map((c, index) => ({
    key: String(pickFirst(c.uid, `commission-${index}`)),
    uid: String(pickFirst(c.uid) || '').trim(),
    type: pickFirst(c.type) || '-',
    status: pickFirst(c.status) || '-',
    depth: typeof c.depth === 'number' ? c.depth : 0,
    lots: c.lots != null ? String(c.lots) : '',
    amountMinor: String(c.amount ?? ''),
    amountMicro: String(pickFirst(c.amountMicro, c.amount) ?? ''),
    currency: pickFirst(c.currency) || 'USD',
    partnerUid: String(pickFirst(c.partnerUid, c.partner_uid) || '').trim(),
    clientUid: String(pickFirst(c?.client?.uid, c?.client?.id) || '').trim(),
    clientName: buildProfileName(c?.client),
    created: pickFirst(c.created, c.createdAt, c.created_at),
  }));
}

export function buildCommissionsRequestDto({ type, status, limit, offset } = {}) {
  const dto = { limit: limit || 100, offset: offset || 0 };
  if (type) dto.type = type;
  if (status) dto.status = status;
  return dto;
}
